import { flatten, uniq } from 'lodash';
function Searcher(gamedata) {
  this.gamedata = gamedata;
}

Searcher.prototype.findText = function () {
  const textFilter = this.gamedata.filterComponentsByType(['text']);
  const textComponents = this.gamedata.findComponentsByFilter(textFilter);

  return textComponents;
}

Searcher.prototype.findEvents = function () {
  const eventsFilter = this.gamedata.filterComponentsByType(['emitEvent', 'onEvent']);
  const eventsComponents = this.gamedata.findComponentsByFilter(eventsFilter);

  let events = flatten(eventsComponents.map( (component) => {
    return (component.event || component.eventName);
  }))

  const onEventTransforms = this.gamedata.filterComponentsByType(['onEventTransform']);
  const transformsAndSource = this.gamedata.findComponentsAndSourceByFilter(onEventTransforms);
  const transformsWithEventComponents = this.gamedata.findTransformsAndSourceForComponentsAndSource(transformsAndSource);

  let onEventTransformEvents = flatten(transformsWithEventComponents.map( ({transforms}) => {
    return flatten(transforms.map( ({children}) => {
      return flatten(children.map( ({vars}) => {
        return vars.eventName;
      }));
    }));
  }));


  events = events.concat(onEventTransformEvents);
  events = flatten(events.map( (c) => {
    return c.split(",");
  }));
  events = events.filter( (e) => {
    return e !== "";
  });
  events = uniq(events);
  events.sort();

  return events;
}

Searcher.prototype.findPhysicsBodies = function () {
  const eventsFilter = this.gamedata.filterComponentsByType(['physicsbody2d']);
  const eventsComponents = this.gamedata.findComponentsByFilter(eventsFilter);

  return eventsComponents;
}

Searcher.prototype.findTransformsForTypes = function (types) {
  const filter = this.gamedata.filterComponentsByType(types);
  const componentsAndSource = this.gamedata.findComponentsAndSourceByFilter(filter);
  const transformsAndSource = this.gamedata.findTransformsAndSourceForComponentsAndSource(componentsAndSource);
  return flatten(transformsAndSource.map( (LOL) => {
    return LOL.transforms
  }));
  const transformsWithEventComponents = this.gamedata.findTransformsAndSourceForComponentsAndSource(transformsAndSource);

  let onEventTransformEvents = flatten(transformsWithEventComponents.map( ({transforms}) => {
    return flatten(transforms.map( ({children}) => {
      return flatten(children.map( ({vars}) => {
        return vars.eventName;
      }));
    }));
  }));
}

Searcher.prototype.findAnimationsFromTransformComponent = function (component) {
  console.log('my components', component);
  return component.anims;
}

export default Searcher;
